import React from 'react';
import { Card, CardContent, Grid, List, ListItem, TextField, Button } from '@material-ui/core';
import { Add, Remove } from '@material-ui/icons';
import ArticleField from '../ArticleField';

export interface ReadExternItem {
	linktext: string,
	linkurl: string,
	linktitle: string,
}

export interface ReadExternSimpleProps {
	value: ReadExternItem,
	onChange: (newValue: ReadExternItem) => void,
}

const ReadSingle = (props: ReadExternSimpleProps) => (
	<ListItem>
		<Grid direction="row" container spacing={2}>
			<Grid item xs={4}>
				<TextField label="Texte du lien" fullWidth value={props.value.linktext} onChange={(e) => {
					props.onChange({
						...props.value,
						linktext: e.target.value,
					});
				}} />
			</Grid>
			<Grid item xs={4}>
				<TextField label="URL du lien" fullWidth value={props.value.linkurl} onChange={(e) => {
					props.onChange({
						...props.value,
						linkurl: e.target.value,
					});
				}} />
			</Grid>
			<Grid item xs={4}>
				<TextField label="Titre du lien (infobulle)" fullWidth value={props.value.linktitle} onChange={(e) => {
					props.onChange({
						...props.value,
						linktitle: e.target.value,
					});
				}} />
			</Grid>
		</Grid>
	</ListItem>
);

export interface ReadExternProps {
	value: ReadExternItem[],
	onChange: (newValue: ReadExternItem[]) => void
}

const ReadExtern = (props: ReadExternProps) => (
	<ArticleField label="Lire aussi externes">
		<Card>
			<CardContent>
				<List>
					{props.value && props.value.filter(e => e != null).map((e, i) => (
						<ReadSingle key={i} value={e} onChange={(newValue) => {
							const value = [...props.value]
							value[i] = newValue;
							props.onChange(value);
						}} />
					))}
				</List>
				<Grid
					container
					alignItems="center"
					direction="column">
					<Grid item>
						<Button onClick={(e) => props.onChange([...props.value, { linktext: "", linkurl: "", linktitle: "" }])}>
							<Add />
						</Button>
						<Button disabled={!props.value || props.value.length < 2} onClick={(e) => {
							const tmpArray = [...props.value];
							tmpArray.splice(-1, 1);
							props.onChange(tmpArray);
						}}>
							<Remove />
						</Button>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	</ArticleField>
);

export default ReadExtern;

export { ReadSingle };